import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import Sidebar from './components/Sidebar';
import Topbar from "./components/Topbar";
import FloatingPointReportCard from '../../admin/components/report/FloatingPointReportCard';

const UserFloatingPointReport = ({ distributor, token }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false)

    useEffect(() => {
        if (!distributor || !distributor.floating_point_report) history.push("/distributor");
    }, [])

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={e => setToggled(!toggled)} />
            <div className="admin-page">
                <Topbar handleToggle={e => setToggled(!toggled)} />
                <div className="admin-content">
                    <FloatingPointReportCard
                        token={token}
                        role="distributor"
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        distributor: state.distributor.distributor,
        token: state.distributor.token
    };
};

export default connect(mapStateToProps, null)(UserFloatingPointReport);